const importComponentsFn = require.context('./', true, /\.vue$/)
export default {
  install(app) {
    importComponentsFn.keys().forEach(key => {
      // 批量导入组件
      const component = importComponentsFn(key).default

      // 使用组件名进行注册组件
      app.component(component.name, component)
    })
  }
}


// WEBPACK FOOTER //
// src/components-mall/index.js